/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Filter_OnlineInputs */

const en_directory_filter_online = /** @type {(inputs: Directory_Filter_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Online only`)
};

const pl_directory_filter_online = /** @type {(inputs: Directory_Filter_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tylko online`)
};

/**
* | output |
* | --- |
* | "Online only" |
*
* @param {Directory_Filter_OnlineInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_filter_online = /** @type {((inputs?: Directory_Filter_OnlineInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Filter_OnlineInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_filter_online(inputs)
	return en_directory_filter_online(inputs)
});